import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";
import { ArrowRight } from "lucide-react";

const SERVICES = [
  {
    id: "bronz_organic_clasic",
    name: "Bronz Organic Clasic",
    duration: "25 min",
    price: "90 RON",
    description:
      "Bronz natural, uniform și elegant fără expunere la UV. Perfect pentru evenimente, vacanțe sau pentru un aspect sănătos și radiant.",
    includes: [
      "Consultare personalizată inclusă",
      "Alegerea nuanței potrivite",
      "Aplicare profesională spray tan organic",
      "Produse premium Norvell și Sjolie",
      "Instrucțiuni pentru întreținerea bronzului",
    ],
    image: IMAGES.serviceBronzeIntense,
    highlight: false,
  },
  {
    id: "sticker_glow_experience",
    name: "Sticker Glow Experience",
    duration: "25 min",
    price: "110 RON",
    description:
      "Experiența noastră specială. Înainte de aplicare alegi modele realizate cu stickere speciale pentru efecte unice și distractive după dezvoltarea bronzului.",
    includes: [
      "Consultare personalizată inclusă",
      "Stickere decorative pentru efecte personalizate",
      "Aplicare profesională spray tan organic",
      "Produse premium Norvell și Sjolie",
      "Instrucțiuni pentru întreținerea bronzului",
    ],
    image: IMAGES.serviceHeartSticker,
    highlight: true,
  },
];

export default function Services() {
  const r = useReveal();
  return (
    <section
      id="servicii"
      data-testid="services-section"
      className="py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div ref={r.ref} className={`flex items-end justify-between flex-wrap gap-6 mb-14 ${r.className}`}>
          <div className="max-w-2xl">
            <div className="section-label mb-4">Serviciile noastre</div>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
              Bronz <em className="italic text-[#B88746]">croit pentru tine</em>
            </h2>
          </div>
          <p className="text-[#3B2A22]/70 max-w-md">
            De la nuanțe subtile la accente luminoase — fiecare serviciu este personalizat
            după tipul tău de piele și ocazia ta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ s, index }) {
  const r = useReveal();
  return (
    <article
      ref={r.ref}
      className={r.className}
      style={{ transitionDelay: `${index * 80}ms` }}
      data-testid={`service-card-${s.id}`}
    >
      <div
        className={`group rounded-[1.5rem] overflow-hidden border transition-all duration-500 h-full flex flex-col ${
          s.highlight
            ? "bg-[#3B2A22] text-[#FFFDF9] border-[#3B2A22]"
            : "bg-[#FFFDF9] border-[#D7B899]/40 hover:border-[#B88746]/60"
        }`}
      >
        <div className="img-zoom aspect-square w-full overflow-hidden">
          <img
            src={s.image}
            alt={s.name}
            className="w-full h-full object-cover object-center"
            data-testid={`service-image-${s.id}`}
          />
        </div>
        <div className="p-7 flex flex-col flex-1 gap-4">
          <div className="flex items-center justify-between text-xs uppercase tracking-[0.2em]">
            <span style={{ color: s.highlight ? "#D7B899" : "#B88746" }}>
              {s.duration}
            </span>
            <span className={s.highlight ? "text-[#FFFDF9]" : "text-[#3B2A22]"}>
              {s.price}
            </span>
          </div>
          <h3 className="font-serif text-2xl leading-tight">{s.name}</h3>
          <p
            className={`text-sm leading-relaxed ${
              s.highlight ? "text-[#FFFDF9]/75" : "text-[#3B2A22]/70"
            }`}
          >
            {s.description}
          </p>
          {s.includes && (
            <ul className="space-y-1.5 pt-1">
              {s.includes.map((inc) => (
                <li
                  key={inc}
                  className={`flex items-start gap-2 text-xs ${
                    s.highlight ? "text-[#FFFDF9]/80" : "text-[#3B2A22]/70"
                  }`}
                >
                  <span
                    className="mt-1.5 inline-block w-1 h-1 rounded-full flex-shrink-0"
                    style={{ background: s.highlight ? "#D7B899" : "#B88746" }}
                  />
                  <span>{inc}</span>
                </li>
              ))}
            </ul>
          )}
          <a
            href="#rezervare"
            data-testid={`service-book-${s.id}`}
            className={`inline-flex items-center gap-2 mt-auto pt-3 text-sm font-medium tracking-wide uppercase ${
              s.highlight ? "text-[#FFFDF9]" : "text-[#B88746]"
            }`}
          >
            Rezervă acum <ArrowRight size={14} strokeWidth={1.8} />
          </a>
        </div>
      </div>
    </article>
  );
}
